<template>
  <b-button class="float-right m-1" size="sm" variant="outline-secondary" @click="agir">
    <font-awesome-icon icon="trash" class="mr-2" />
    Limpar
  </b-button>
</template>

<script>
/**
 * Um botão simples, formatado para ser renderizado nos cabeçalhos de card de nossas páginas.
 * @since 20220627
 */
export default {
  name: "BtnLimpar",
  props: {
    clearMethod: { type: Function, required: true },
  },
  methods: {
    agir(e) {
      e.stopPropagation()
      this.clearMethod()
    }
  }
};
</script>